
import './Banner.css'
function Banner() {
    return (
        <header className="banner"> 
            <img src="/imagens/banner.png" alt="hero image azul" />
        </header>
    )
}

export default Banner